<template>
  <div>
    <v-container>
      <pv-hero
        :title="$t('page.audioFiles.title')"
      />
    </v-container>
    <v-main>
      <v-container v-if="loadError">
        <v-alert type="error">
          {{ $t('page.audioFiles.errors.cannotLoadList') }}
        </v-alert>
      </v-container>
      <v-container v-if="audioFiles">
        <div class="c-hero__meta">
          <div class="c-hero__metaItem">
            <span class="c-hero__metaItemTitle">{{ $t('page.audioFiles.meta.examSubjectNumber') }}</span>
            <span class="c-hero__metaItemValue">
              {{ audioFiles.examSubjectId }}
            </span>
          </div>
          <div class="c-hero__metaItem">
            <span class="c-hero__metaItemTitle">{{ $t('page.audioFiles.meta.version') }}</span>
            <span class="c-hero__metaItemValue">
              {{ audioFiles.version }}
            </span>
          </div>
          <div class="c-hero__metaItem">
            <span class="c-hero__metaItemTitle">{{ $t('page.audioFiles.meta.playableFrom') }}</span>
            <span class="c-hero__metaItemValue">
              {{ formatDate(audioFiles.from, 'DD.MM.YYYY HH:mm') }}
            </span>
          </div>
          <div class="c-hero__metaItem">
            <span class="c-hero__metaItemTitle">{{ $t('page.audioFiles.meta.playableUntil') }}</span>
            <span class="c-hero__metaItemValue">
              {{ formatDate(audioFiles.to, 'DD.MM.YYYY HH:mm') }}
            </span>
          </div>
        </div>
      </v-container>
      <v-container v-if="audioFiles">
        <v-row
          v-for="(file, index) in audioFiles.fileNames"
          :key="file"
          align="center"
        >
          <v-col cols="12">
            <div class="d-flex align-center mb-2">
              <div class="text-subtitle-1">
                {{ index + 1 }}
              </div>
            </div>
            <audio
              v-if="fileUrls[file] && isAudio(file)"
              controls
              controlsList="nodownload noplaybackrate"
              style="width: 100%;"
              @ratechange="disablePlaybackRate"
              @contextmenu.prevent
            >
              <source
                :src="fileUrls[file]"
                type="audio/mpeg"
              >
              {{ $t('page.audioFiles.errors.noAudioTagSupport') }}
            </audio>
            <v-btn
              v-else-if="fileUrls[file] && isPdf(file)"
              :href="fileUrls[file]"
              :download="file"
              color="primary"
              target="_blank"
              rel="noopener"
              text
            >
              <v-icon left>
                mdi-download
              </v-icon>
              {{ file }}
            </v-btn>
            <v-alert
              v-else-if="fileErrors[file]"
              type="error"
              dense
              text
            >
              {{ $t('page.audioFiles.errors.cannotLoadAudioFile', {number: index + 1}) }}
            </v-alert>
            <v-progress-linear
              v-else
              indeterminate
              color="primary"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import {dateTimeMixin} from "@/mixins/date-time";
import pvHero from "@/components/Hero";

export default {
  name: 'AudioFiles',
  components: {
    pvHero
  },
  mixins: [dateTimeMixin],
  inject: [
    'pruefungsverwaltung'
  ],
  data: () => ({
    audioFiles: null,
    isDestroyed: false,
    fileUrls: {},
    fileErrors: {},
    loadError: false
  }),
  computed: {
    eiUuid() {
      return localStorage.getItem('eiUuid') || this.$route.query.institute;
    }
  },
  created() {
    if (!this.$route.params.id) {
      return;
    }
    this.pruefungsverwaltung.getAudioFiles(this.eiUuid, this.$route.params.id).then(({data}) => {
      this.audioFiles = data;
      for (const fileName of this.audioFiles.fileNames) {
        this.pruefungsverwaltung.getAudioFile(this.eiUuid, this.$route.params.id, fileName).then((resp) => {
          if (this.isDestroyed) {
            return;
          }
          this.$set(this.fileUrls, fileName, URL.createObjectURL(resp.data));
        }).catch((err) => {
          if (this.isDestroyed) {
            return;
          }
          const detail = err.response ? `HTTP ${err.response.status}` : 'Network error';
          this.$set(this.fileErrors, fileName, detail);
        });
      }
    }).catch(() => {
      if (!this.isDestroyed) {
        this.loadError = true;
      }
    });
  },
  beforeDestroy() {
    this.isDestroyed = true;
    for (const url of Object.values(this.fileUrls)) {
      URL.revokeObjectURL(url);
    }
  },
  methods: {
    isAudio(fileName) {
      const normalizedFileName = fileName.toLowerCase();

      return normalizedFileName.endsWith('.mp3') ||
        normalizedFileName.endsWith('.mpeg') ||
        normalizedFileName.endsWith('.mp4') ||
        normalizedFileName.endsWith('.m4a') ||
        normalizedFileName.endsWith('.wav');
    },
    isPdf(fileName) {
      const normalizedFileName = fileName.toLowerCase();

      return normalizedFileName.endsWith('.pdf');
    },
    disablePlaybackRate(event) {
      if (event.target.playbackRate !== 1.0) {
        event.target.playbackRate = 1.0;
      }
    }
  }
}
</script>
